import React from 'react';
import '../../style/generalTab.css';
import GeneralSVG from "../generalSVG";
import FormGroupPlainText from "../formGroupPlainText";
import moment from 'moment';
import _ from 'lodash';
import CenteredDots from "../General/centeredDots";
import { POLICY_SCHEDULE } from '../../helpers/constants'; 

const PolicyTabSchedule = (props) => {
    let Label;
    let value;
    let fileName = 'ARAG_Policy_' + POLICY_SCHEDULE + '_' + props.selectedApp.aragReference + '_' + _.replace(props.selectedApp.clientName, / /g, '_') +'.pdf';
    Label = <div>
        <p className="applicationPolicy-paragraph textBold">{props.selectedApp.aragReference}</p>
        <p className="applicationPolicy-paragraph">{ props.selectedApp.liveDate? moment(props.selectedApp.liveDate).format('DD/MM/YYYY HH:mm:ss'):''}</p>
    </div>;
    value = <div className="">
                    <span className="col-sm-12">
                        {fileName}
                    </span>
        <div className="col-sm-12">
            <div style={{display:'flex'}}
                    onClick={() => props.downloadPolicySchedule()}
                className="inlineBlock mousePointer">
                <GeneralSVG
                    SvgWrapper="generalTab-download-wrapper"
                    Label="Download"
                    Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><title>Asset 9</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="info">
                                <path
                                    d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                <path
                                    d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                            </g>
                        </g>
                    </svg>}
                />
               <div style={{marginLeft:30}}> {props.fetchingPolicy && <CenteredDots/>}</div>
            </div>
        </div>
    </div>;

    return (
        <div className="col-sm-12 generalTab-wrapper">
            <form className="form-horizontal">
                <FormGroupPlainText
                    Label={Label}
                    InputWrapper="manageSolicitorAccount-data col-xs-9"
                    Text={value}
                />
            </form>
        </div>
    )
};

export default PolicyTabSchedule;
